import React from "react";
import {Calendar, momentLocalizer} from "react-big-calendar";
import moment from 'moment'

const localizer = momentLocalizer(moment)

const events = [];

function Planner () {

    return (
        <Calendar
            localizer={localizer}
            startAccessor="start"
            endAccessor="end"
            events={events}
            style={{ height: "50vh" }}
            views={['day', 'week', 'month']}

        />
    )
}

export default Planner;